export const WIDGET_ID = 'f5df9e2e9660189338f9ba0588abe99526c96ec19ef4dca6aae88d80b58c2620';
export const WIDGET_SRC = `https://www.onedoc.ch/de/widget/${WIDGET_ID}`;
